var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemovenotitifcationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(-36 -734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_281",
    "data-name": "Ellipse 281",
    transform: "translate(36 734)",
    fill: "#fff",
    stroke: "#373334",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Add",
    transform: "translate(42.967 734.61) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    y2: 9,
    transform: "translate(4.5)",
    fill: "none",
    stroke: "#373334",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    x2: 9,
    transform: "translate(0 4.374)",
    fill: "none",
    stroke: "#373334",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovenotitifcationicon);
export default __webpack_public_path__ + "static/media/removenotitifcationicon.28f1bc7caf1f215b4f3139cc360c0991.svg";
export { ForwardRef as ReactComponent };